import React from 'react';
import { useQuery, Loading, Error } from 'react-admin';

const IsNot2ndPhysical = (ssn) =>{

    const { data, loading, error } = useQuery({ 
        type: 'getOne',
        resource: '2ndphysical',
        payload: { id: (ssn) ? ssn: null}
    });
   
    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;

    var result  = (data[0] && data[0].ssn)? false : true;
/*
    if(result){
        document.getElementById("anato") && document.getElementById("anato").setAttribute("style", "display: none;");
        document.getElementById("tattoo") && document.getElementById("tattoo").setAttribute("style", "display: none;");
        document.getElementById("medic") && document.getElementById("medic").setAttribute("style", "display: none;");
        document.getElementById("consent") && document.getElementById("consent").setAttribute("style", "display: none;");
    }
*/
    return result
}

export default IsNot2ndPhysical